<template>
  <apexchart :options="chartOptions" :series="chartsData" type="line" height="356" />
</template>

<script>
import ruLocale from "../../../../../common/apexcharts/ru.json";

export default {
  name: "Chart",
  props: {
    chartsData: {
      type: Array,
      default: () => [
        {
          name: "План",
          data: []
        },
        {
          name: "Факт",
          data: []
        }
      ]
    },
    categories: {
      type: Array,
      default: () => []
    },
    yaxisTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          id: "chartArea",
          locales: [ruLocale],
          defaultLocale: "ru",
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          }
        },
        colors: ["#6080D3", "#E04C0D"],
        stroke: {
          width: 3
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          opacity: 1
        },
        markers: {
          size: 0,
          hover: {
            size: 3
          }
        },
        xaxis: {
          title: {
            text: "Год"
          },
          labels: {
            style: {
              colors: "rgba(0, 0, 0, 0.4)",
              fontSize: "12px",
              fontFamily: "'Open Sans', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
            }
          },
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          tooltip: {
            enabled: false
          },
          crosshairs: {
            show: false
          }
        },
        yaxis: {
          decimalsInFloat: 0,
          labels: {
            style: {
              color: "rgba(0, 0, 0, 0.4)",
              fontSize: "12px",
              fontFamily: "'Open Sans', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
            }
          }
        },
        tooltip: {
          x: {
            show: false
          },
          y: {
            formatter: value => value
          }
        },
        legend: {
          color: "rgba(0, 0, 0, 0.4)",
          fontSize: "12px",
          fontFamily: "'Open Sans', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          offsetY: -4,
          labels: {
            colors: ["rgba(0, 0, 0, 0.4)"]
          },
          itemMargin: {
            vertical: 8
          },
          markers: {
            width: 10,
            height: 10,
            radius: 10
          }
        },
        grid: {
          borderColor: "rgba(0, 0, 0, 0.2)",
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        }
      }
    };
  },
  watch: {
    categories(newValues) {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: newValues
          }
        }
      };
    },
    yaxisTitle(newValues) {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          yaxis: {
            ...this.chartOptions.yaxis,
            ...{
              title: {
                text: newValues
              }
            }
          }
        }
      };
    }
  },
  created() {
    this.chartOptions = {
      ...this.chartOptions,
      ...{
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: this.categories
        },
        yaxis: {
          ...this.chartOptions.yaxis,
          ...{
            title: {
              text: this.yaxisTitle
            }
          }
        }
      }
    };
  }
};
</script>
